import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import constants from '@core/utils/constants';

// ============ START RAPIDOO CONNECT ============
bus.on(constants.EVENTS.REWARDS.START, async () => {
  const store = getStore('rewards');
  const userStore = getStore('user');
  const userId = userStore?.state?.current?.id;

  if (!userId) {
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      type: 'error',
      title: 'Connexion requise',
      body: 'Vous devez être connecté pour démarrer Rapidoo Connect.'
    });
    return;
  }

  try {
    bus.emit(constants.EVENTS.LOADING.START);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: 'start-rapidoo-connect',
      url: constants.ENDPOINTS.REWARDS.PROFILE_CREATE,
      method: 'POST',
      data: { userId }
    });

    const handler = (res) => {
      if (res.id === 'start-rapidoo-connect') {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        setTimeout(() => {
          bus.emit(constants.EVENTS.LOADING.FINISH);
        }, 300);

        if (
          res.success &&
          (res.data?.statusCode === 201 || res.data?.statusCode === 200)
        ) {
          // Immediately fetch the actual profile now that it's created
          bus.emit(constants.EVENTS.REWARDS.FETCH_PROFILE);

          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            type: 'success',
            title: 'Rapidoo Connect démarré!',
            body: 'Gagnez des XP à chaque commande et débloquez des récompenses.'
          });

          bus.emit(constants.EVENTS.REWARDS.LOAD_LEVELS);
        } else {
          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            type: 'error',
            title: 'Erreur',
            body: res.data?.message || 'Impossible de démarrer Rapidoo Connect'
          });
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  } catch (error) {
    setTimeout(() => {
      bus.emit(constants.EVENTS.LOADING.FINISH);
    }, 300);

    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      type: 'error',
      title: 'Erreur',
      body: error.message
    });
  }
});

// ============ FETCH GAMIFICATION PROFILE ============
bus.on(constants.EVENTS.REWARDS.FETCH_PROFILE, async () => {
  const store = getStore('rewards');
  const userStore = getStore('user');
  const userId = userStore?.state?.current?.id;

  console.log('🎮 FETCH_PROFILE called, userId:', userId);

  if (!userId) {
    // Not logged in, skip fetching profile
    console.log('🎮 No userId, skipping profile fetch');
    return;
  }

  try {
    const reqIdProgress = 'fetch-progress-' + Date.now();
    const reqIdMilestones = 'fetch-milestones-' + Date.now();

    let progressData = null;
    let milestonesData = null;
    let responsesReceived = 0;

    const checkComplete = () => {
      if (responsesReceived === 2) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);

        if (!progressData) {
          // If profile is null or 404, user hasn't started Rapidoo Connect yet
          store.state.userLevelData = {
            level: 1,
            activeMilestone: 'firstOrder',
            xpPercent: 0,
            currentXp: 0,
            totalXp: 0,
            requiredLevelXp: 0,
            isElligible: false // Not eligible until they click "Démarrer"
          };
          store.state.levelName = getLevelName(1);
          store.state.gamificationProfile = null;
          bus.emit(constants.EVENTS.REWARDS.PROFILE_LOADED, null);
          return;
        }

        const xpFromCurrentLevelToNext =
          progressData.nextLevel?.requiredXp -
            progressData.currentLevel?.requiredXp || 0;
        const xpGotForCurrentLevel =
          progressData?.xp - progressData.currentLevel?.requiredXp || 0;
        const currentLevelXpProgress =
          (xpGotForCurrentLevel / xpFromCurrentLevelToNext) * 100 || 0;

        // Update store with gamification profile
        store.state.userLevelData = {
          level: progressData.currentLevel?.level || 1,
          xpPercent: progressData.progress || 0,

          xpFromCurrentLevelToNext,
          xpGotForCurrentLevel,
          currentLevelXpProgress: Math.min(
            Math.max(currentLevelXpProgress, 10),
            100
          ),

          currentXp: progressData.xp || 0,
          totalXp: progressData.xp || 0,
          requiredLevelXp: progressData.xpRequired || 0,
          isElligible: true // Eligible if progress data exists
        };

        store.state.levelName =
          progressData.currentLevel?.name ||
          getLevelName(progressData.currentLevel?.level || 1);
        store.state.userPoints = progressData.points || 0;
        store.state.milestones = milestonesData || [];
        store.state.badges = [];
        store.state.gamificationProfile = progressData; // store progress as profile

        bus.emit(constants.EVENTS.REWARDS.PROFILE_LOADED, progressData);
      }
    };

    const handler = (res) => {
      if (res.id === reqIdProgress) {
        responsesReceived++;
        if (res.success && res.data?.statusCode === 200) {
          progressData = res.data.data;
          console.log('🚀 ~ handler ~ progressData:', progressData);
          // progressData = {
          //   userId: 'curptlcjfmzz5wftje51hw8olzijlu',
          //   xp: 0,
          //   points: 0,
          //   currentLevel: {
          //     level: 1,
          //     name: 'Beginner',
          //     requiredXp: 100
          //   },
          //   nextLevel: {
          //     level: 2,
          //     name: 'Real Explorer',
          //     requiredXp: 500
          //   },
          //   progress: 0,
          //   xpRemaining: 500,
          //   xpRequired: 500
          // };
          // progressData = {
          //   userId: 'curptlcjfmzz5wftje51hw8olzijlu',
          //   xp: 42000,
          //   points: 0,
          //   currentLevel: {
          //     level: 15,
          //     name: 'The levele',
          //     requiredXp: 40000
          //   },
          //   nextLevel: {
          //     level: 16,
          //     name: 'Real Explorer',
          //     requiredXp: 49000
          //   },
          //   progress: 0,
          //   xpRemaining: 7000,
          //   xpRequired: 49000
          // };
          // progressData = {
          //   userId: 'xkdln54s9f01pembbofwxdgvcori2u',
          //   xp: 89000,
          //   points: 100,
          //   currentLevel: {
          //     level: 3,
          //     name: 'The levele',
          //     requiredXp: 1000
          //   },
          //   nextLevel: null,
          //   progress: 100,
          //   xpRemaining: 0,
          //   xpRequired: null
          // };
        }
        checkComplete();
      } else if (res.id === reqIdMilestones) {
        responsesReceived++;
        if (res.success && res.data?.statusCode === 200) {
          milestonesData = res.data.data;
        }
        checkComplete();
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);

    // Launch requests
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqIdProgress,
      url: constants.ENDPOINTS.REWARDS.PROFILE_PROGRESS.replace(
        ':userId',
        userId
      ),
      method: 'GET'
    });

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqIdMilestones,
      url: constants.ENDPOINTS.REWARDS.PROFILE_MILESTONES.replace(
        ':userId',
        userId
      ),
      method: 'GET'
    });
  } catch (error) {
    console.error('🎮 Error in FETCH_PROFILE:', error);
    bus.emit(constants.EVENTS.REWARDS.PROFILE_LOADED, null);
  }
});

// Helper: Get level name from level number
function getLevelName(level) {
  const levelNames = {
    1: 'Nouveau client',
    2: 'Découvreur',
    3: 'Client actif',
    4: 'Client fidèle',
    5: 'Explorateur gourmand',
    6: 'Client régulier',
    7: 'Ambassadeur local',
    8: 'Adepte des bonnes adresses',
    9: 'Client Premium',
    10: 'Client Gold',
    11: 'Connaisseur',
    12: 'Membre privilégié',
    13: 'Client influent',
    14: 'Épicurien confirmé',
    15: 'Client VIP',
    16: 'Ambassadeur de saveurs',
    17: 'Icône locale',
    18: 'Légende de la livraison',
    19: 'Icône nationale'
  };
  return levelNames[level] || 'Niveau ' + level;
}

bus.on(constants.EVENTS.REWARDS.LOAD_LEVELS, async () => {
  try {
    const reqId = 'load-levels-' + Date.now();
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqId,
      url: constants.ENDPOINTS.REWARDS.LEVELS,
      method: 'GET'
    });

    const handler = (res) => {
      if (res.id === reqId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        if (res.success && res.data?.statusCode === 200) {
          // Levels API returns data.data as the array
          const levels = res.data.data?.data || [];
          bus.emit(constants.EVENTS.REWARDS.LEVELS_LOADED, { result: levels });
        } else {
          bus.emit(constants.EVENTS.REWARDS.LEVELS_LOADED, { result: [] });
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  } catch (error) {
    console.error('Error loading levels:', error);
    bus.emit(constants.EVENTS.REWARDS.LEVELS_LOADED, { result: [] });
  }
});

// ============ LOAD REWARD RULES ============
bus.on(constants.EVENTS.REWARDS.LOAD_RULES, async () => {
  try {
    const reqId = 'load-rules-' + Date.now();
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqId,
      url: constants.ENDPOINTS.REWARDS.RULES,
      method: 'GET'
    });

    const handler = (res) => {
      if (res.id === reqId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        if (res.success && res.data?.statusCode === 200) {
          const rules = Array.isArray(res.data.data) ? res.data.data : [];
          bus.emit(constants.EVENTS.REWARDS.RULES_LOADED, rules);
        } else {
          bus.emit(constants.EVENTS.REWARDS.RULES_LOADED, []);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  } catch (error) {
    console.error('Error loading reward rules:', error);
    bus.emit(constants.EVENTS.REWARDS.RULES_LOADED, []);
  }
});

// ============ LOAD USER MILESTONES ============
bus.on(constants.EVENTS.REWARDS.LOAD_MILESTONES, async () => {
  const userStore = getStore('user');
  const userId = userStore?.state?.current?.id;

  if (!userId) {
    bus.emit(constants.EVENTS.REWARDS.MILESTONES_LOADED, []);
    return;
  }

  try {
    const reqId = 'load-milestones-' + Date.now();
    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqId,
      url: constants.ENDPOINTS.REWARDS.PROFILE_MILESTONES.replace(
        ':userId',
        userId
      ),
      method: 'GET'
    });

    const handler = (res) => {
      if (res.id === reqId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        if (res.success && res.data?.statusCode === 200) {
          const milestones = Array.isArray(res.data.data) ? res.data.data : [];
          bus.emit(constants.EVENTS.REWARDS.MILESTONES_LOADED, milestones);
        } else {
          bus.emit(constants.EVENTS.REWARDS.MILESTONES_LOADED, []);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  } catch (error) {
    console.error('Error loading milestones:', error);
    bus.emit(constants.EVENTS.REWARDS.MILESTONES_LOADED, []);
  }
});

// NOTE: LOAD and LOAD_ERROR are left mostly identical but you may map them to levels or profile if they serve another purpose.
// Often LOAD was used as a generic trigger. We just trigger FETCH_PROFILE.
bus.on(constants.EVENTS.REWARDS.LOAD, async () => {
  bus.emit(constants.EVENTS.REWARDS.FETCH_PROFILE);
});

bus.on(constants.EVENTS.REWARDS.CLAIM, async (milestone) => {
  const store = getStore('rewards');

  // Get userId for authenticated request
  const userStore = getStore('user');
  const userId = userStore?.state?.current?.id;

  if (!userId) {
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Erreur',
      body: 'Vous devez être connecté pour claimer une récompense'
    });
    return;
  }

  try {
    const reqId = `claim-milestone-${milestone.id}-${Date.now()}`;
    const url = constants.ENDPOINTS.REWARDS.MILESTONE_CLAIM.replace(
      ':userId',
      userId
    ).replace(':milestoneId', milestone.id);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: reqId,
      url: url,
      method: 'POST'
    });

    const handler = (res) => {
      if (res.id === reqId) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
        if (res.success && res.data?.statusCode === 200) {
          bus.emit(constants.EVENTS.REWARDS.CLAIMED, res.data.data);
          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Récompense réclamée!',
            body: 'Félicitations!'
          });
          // Refresh profile after claim
          bus.emit(constants.EVENTS.REWARDS.FETCH_PROFILE);
          bus.emit(constants.EVENTS.REWARDS.LOAD_MILESTONES);
          if (milestone.rewards.map((r) => r.type).includes('badge')) {
            const rewardBadges = milestone.rewards
              .filter((r) => r.type === 'badge')
              .map((r) => r.value);
            const badges = userStore?.state?.current?.metadata?.badges || [];
            const newBadges = rewardBadges.filter((b) => !badges.includes(b));
            if (newBadges.length === 0) {
              return;
            }
            bus.emit(constants.EVENTS.USER.UPDATE, {
              metadata: {
                badges: [...badges, ...newBadges]
              }
            });
          }
        } else {
          bus.emit(constants.EVENTS.REWARDS.NOT_CLAIMED);
          bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
            title: 'Erreur',
            body:
              res.data?.message || 'Echec de réclamation de cette récompense'
          });
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
  } catch (error) {
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      title: 'Erreur',
      body: error.message
    });
  }
});

// ============ FETCH USER LEVEL ============
bus.on(constants.EVENTS.REWARDS.FETCH_USER_LEVEL, async () => {
  try {
    // Get the rewards store to access level data
    const store = getStore('rewards');

    // Get level data from rewards store
    const levelData = {
      userLevel: store?.state?.userLevel || 1,
      levelName: store?.state?.levelName || 'Débutant',
      userPoints: store?.state?.userPoints || 0,
      stats: store?.state?.stats || {
        total: 0,
        locked: 0,
        active: 0,
        claimed: 0
      }
    };

    // Emit level updated event
    bus.emit(constants.EVENTS.REWARDS.LEVEL_UPDATED, levelData);
  } catch (error) {
    console.error('Error fetching user level:', error);
    // Emit with default values on error
    bus.emit(constants.EVENTS.REWARDS.LEVEL_UPDATED, {
      userLevel: 1,
      levelName: 'Débutant',
      userPoints: 0,
      stats: { total: 0, locked: 0, active: 0, claimed: 0 }
    });
  }
});
